import env from 'bench-environment';

/**
 * @typedef {Object} TokenResponse
 * @property {String} chatToken
 * @property {String} clientId
 *
 * Retrieve token representing user's permissions to listen to PubNub events.
 * @returns {Promise<TokenResponse>}
 */
const getUserChatToken = async () => {
  const chatTokenEndpoint = `${env.location.apiRoot}/api/v1/token.json/chat`;
  const response = await fetch(chatTokenEndpoint, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.json();
};

export default getUserChatToken;
